/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MuiLink from "@mui/material/Link";

// @mui icons
import { Instagram, Facebook } from "@mui/icons-material";


function Services() {
  return (
    <MKBox component="section" py={6}>
      <Container>
        <Grid container item xs={12} lg={6}>
          <MKTypography variant="h3" mb={8}>
            Seguinos en nuestras redes sociales
          </MKTypography>
        </Grid>
        <Grid container spacing={3} justifyContent="center" alignItems="center">
          <Grid
            container
            spacing={3}
            justifyContent="center"
            alignItems="center"
            sx={{ mt: 1, mb: 2 }}
          >
            <Grid item xs={2} display="flex" justifyContent="center" alignItems="center">
              <MKTypography
                component={MuiLink}
                href="https://www.facebook.com/Seoul.Concesionario.Oficial.Hyundai"
                target="_blank"
                rel="noopener noreferrer"
                variant="h1"
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                <Facebook color="inherit" />
              </MKTypography>
            </Grid>
            <Grid item xs={2} display="flex" justifyContent="center" alignItems="center">
              <MKTypography
                component={MuiLink}
                href="https://www.instagram.com/seoulmotor/"
                target="_blank"
                rel="noopener noreferrer"
                variant="h1"
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                <Instagram color="inherit" />
              </MKTypography>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Services;
